import axios from 'axios';
import { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../stores/hooks';
import { updateauthapi } from '../stores/authslice';
import { showerrormessage } from '../stores/notificationslice';
import { addrequestcounter, reducerequestcounter } from '../stores/commonslice';
import { closeDialog } from '../stores/updatepasswordslice';
import { PublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
const tracs_api = axios.create();
const tracs_api_bg=axios.create();

const AxiosInterceptor = ({ msalinstance,children }: {msalinstance:PublicClientApplication, children: any }) => {
    const isAuthenticated = useAppSelector((state) => state.authReducer.IsAuthenticated);
    const dispatch = useAppDispatch();
    // Fetch the CSRF token
const fetchCsrfToken = async (apiUrl:string,accessToken:string) => {
     var antiforgeryUrl= apiUrl.substring(0,apiUrl.lastIndexOf('/'));
    const response = await axios.get(antiforgeryUrl+'/token',{
        headers: {
            'Authorization': accessToken
        }}
    );
};
    useLayoutEffect(() => {
        const reqInterceptorFn = async (config: any) => {
            
            dispatch(addrequestcounter());
            const account = msalinstance.getAllAccounts()[0];
    const msalResponse = await msalinstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    config.headers.Authorization = `Bearer ${ msalResponse.accessToken }`;
     
            return config;
        }

        const reqInterceptorFnBg = async (config: any) => {
            const account = msalinstance.getAllAccounts()[0];
            const msalResponse = await msalinstance.acquireTokenSilent({
              ...loginRequest,
              account: account,
            });
            config.headers.Authorization = `Bearer ${ msalResponse.accessToken }`;
                    return config;
        }
        const resInterceptor = (response: any) => {
            dispatch(reducerequestcounter());
            return response;
        }

        const resInterceptorBg = (response: any) => {
            return response;
        }

        const errInterceptor = (error: any) => {
            dispatch(reducerequestcounter());
            if (error.code === 'ERR_NETWORK') {
                dispatch(showerrormessage('A network error occured. Please check your network connection or try agin.'));
            }
            else {
                if (error && error.response && error.response.status === 401 && isAuthenticated) {
                    let locationSplit = window.location.href.split('/');
                    sessionStorage.setItem('redirecturl', '/' + locationSplit[locationSplit.length - 1])
                    //navigate('/login');
                    dispatch(closeDialog);
                } else if (error && error.response){
                    if(error.response.data instanceof ArrayBuffer){
                        let message = String.fromCharCode.apply(
                            null, 
                            new Uint8Array(error.response.data) as any);
                        dispatch(showerrormessage(message));
                    }
                    else
                        dispatch(showerrormessage(error.response.data));
                }
                // else if(error&&error.)
                // else
                //     return Promise.reject(error);
            }



            // return Promise.reject(error);
        }

        const errInterceptorBg = (error: any) => {
            if (error.code === 'ERR_NETWORK') {
                dispatch(showerrormessage('A network error occured. Please check your network connection or try again.'));
            }
            else {
                if (error && error.response && error.response.status === 401 && isAuthenticated) {
                    let locationSplit = window.location.href.split('/');
                    sessionStorage.setItem('redirecturl', '/' + locationSplit[locationSplit.length - 1])
                    //navigate('/login');
                    dispatch(closeDialog);
                } else if (error && error.response){
                    if(error.response.data instanceof ArrayBuffer){
                        let message = String.fromCharCode.apply(
                            null, 
                            new Uint8Array(error.response.data) as any);
                        dispatch(showerrormessage(message));
                    }
                    else
                        dispatch(showerrormessage(error.response.data));
                }
                // else if(error&&error.)
                // else
                //     return Promise.reject(error);
            }



            // return Promise.reject(error);
        }



        const interceptor = tracs_api.interceptors.response.use(resInterceptor, errInterceptor);
        const reqinterceptor = tracs_api.interceptors.request.use(reqInterceptorFn);
        const interceptorbg = tracs_api_bg.interceptors.response.use(resInterceptorBg, errInterceptorBg);
        const reqinterceptorbg = tracs_api_bg.interceptors.request.use(reqInterceptorFnBg);
        dispatch(updateauthapi(true));
        return () => {
            tracs_api.interceptors.response.eject(interceptor);
            tracs_api.interceptors.request.eject(reqinterceptor);
            tracs_api_bg.interceptors.response.eject(interceptorbg);
            tracs_api_bg.interceptors.request.eject(reqinterceptorbg);
        };

    }, [])

    return children;
}


export  {tracs_api,tracs_api_bg};
export { AxiosInterceptor }